<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="styleChartName">
      <div class="head-container-select">
        <div class="flex-row" @click="showOptions = !showOptions">
          <img
            class="head-container-select-text"
            :src="imgText"
            alt="工厂切换"
          />
          <!-- <img
            class="head-container-select-arrow"
            :src="imgArrow"
            alt="三角型"
          > -->
        </div>
        <div
          v-show="showOptions"
          class="options special-options"
          style="background: #ffffff; backdrop-filter: blur(15px)"
        >
          <el-input
            class="customInput"
            v-model="searchVal"
            placeholder="请输入名称"
          >
            <i slot="suffix" class="el-input__icon el-icon-search" />
          </el-input>
          <div class="list">
            <span
              v-for="(fac, index) in filterList"
              :key="fac.value"
              :class="[fac.active ? 'active' : '', 'item']"
              @click="changeFactory(index)"
              >{{ fac.label }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import factoryChange from "@/assets/img/factoryChangeBlue.png";
import areaChange from "@/assets/img/areaChange1.png";
import arrowDown from "@/assets/img/arrowDown.png";
export default {
  name: "headSelect",
  components: {},
  props: {},
  data() {
    return {
      current: 2,
      searchVal: "",
      showOptions: false,
      factories: [],
      imgText: factoryChange,
      imgArrow: arrowDown,
      options: [],
      filterList: [],
      formatData: [],
      fontColor: "",
      fontSize: 14,
      defaultColor: "#0042a554",
      activeColor: "rgba(31, 198, 255, 0.4)",
      defaultValue: "",
    };
  },

  computed: {},
  watch: {
    searchVal(val) {
      if (val) {
        this.filterList = this.factories.filter(
          (item) => item.label.indexOf(val) >= 0
        );
      } else {
        this.filterList = [...this.factories];
      }
    },
  },
  created() {},
  mounted() {
    this.initData();
  },
  destroyed() {},
  methods: {
    initData() {
      // if (this.currentLinkData?.district_name && this.currentLinkData?.district_name.value) {
      //   this.currentLinkData.district_name.value = ''
      // }
      // if (this.currentLinkData?.company && this.currentLinkData?.company.value) {
      //   this.currentLinkData.company.value = ''
      // }
      const { selectType } = this.option;
      const { district = "", company = "" } = this.$route.query;
      if (selectType === "area" && district) {
        this.defaultValue = district;
      } else if (selectType === "factory" && company) {
        this.defaultValue = company;
      }
      this.updateChart();
      // setTimeout(() => {
      // if (this.defaultValue) {
      //   console.log(this.defaultValue)
      //   this.setLinkData(this.dcode, this.defaultValue)
      //   console.log(this.dcode)
      // }
      // }, 1000)
    },
    changeFactory(index) {
      const { value = "" } = this.filterList[index];
      console.log("this.dcode", this.dcode);
      this.setLinkData(this.dcode, value);
      this.showOptions = false;
    },
    updateChart() {
      const { selectType } = this.option;
      if (selectType === "area") {
        this.imgText = areaChange;
      } else {
        this.imgText = factoryChange;
      }
      if (!this.isDataCenter) {
        return;
      }

      const { categories = [], series = [] } = this.getDimentionOption();
      this.factories = categories.map((item) => {
        return {
          label: item,
          value: item,
        };
      });
      this.filterList = [...this.factories];
      if (
        ((!this.$route.query?.district && this.option.selectType === "area") ||
          (!this.$route.query?.company &&
            this.option.selectType === "factory")) &&
        !this.defaultValue &&
        categories.length
      ) {
        this.defaultValue = categories[0];
      }
      if (this.currentLinkData && this.defaultValue) {
        if (this.currentLinkData.district_name) {
          this.currentLinkData.district_name.value = this.defaultValue;
          this.setLinkData(this.dcode, this.defaultValue);
        } else if (this.currentLinkData.company) {
          this.currentLinkData.company.value = this.defaultValue;
          this.setLinkData(this.dcode, this.defaultValue);
        }
        // this.currentLinkData.district.value = this.defaultValue
      }
      // const { plotOptions, colors } = chart_option
      // this.activeColor = colors[0]
      // this.defaultColor = colors[1]
      // const optionKey = (Object.keys(plotOptions) || [])[0]
      // const style = plotOptions[optionKey].dataLabels.style || {}
      // this.fontColor = style.color
      // this.fontSize = style.fontSize
    },
  },
};
</script>

<style lang="scss" scoped>
div.head-container-select {
  position: relative;
  width: 164px;
  height: 34px;
  background-size: cover;
  margin-left: 90px;
}
.flex-row {
  display: flex;
  &:hover {
    cursor: pointer;
  }
}
.head-container-select-arrow {
  height: 20px;
  margin-top: 6px;
}
.head-container-select-text {
  width: 100%;
  height: 100%;
}
.head-container-select .options {
  display: flex;
  flex-direction: column;
  color: #00eaff;
  border: 1px solid #01c2ff;
  border-radius: 4px;
  position: absolute;
  width: 100%;
  min-width: 230px;
  left: -76px;
  height: 258px;
  overflow-y: scroll;
}
.options .item {
  color: #29a394;
  font-size: 14px;
  padding: 5px 10px 5px 10px;
}
.options span:hover {
  cursor: pointer;
  font-weight: 700;
  background: rgba(10, 125, 190, 0.2);
}
.special-options span:hover {
  cursor: pointer;
  font-weight: 700;
  background-color: #279e8f;
  color: #fff;
}
.options .active {
  color: #ffffff;
  background: #279e8f;
}
.options::-webkit-scrollbar {
  width: 2px;
}
.options::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.2);
}
.options::-webkit-scrollbar-track {
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.options {
  .list {
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow-y: auto;
  }
}
.customInput {
  width: calc(100% - 16px);
  margin: 8px auto 4px;
  :deep(.el-input__wrapper) {
    background: #e3f3f3 !important;
    box-shadow: none;
    border-radius: 2px;
  }
  :deep(.el-input__inner) {
    background: transparent;
    border: none;
    color: #28a090;
  }
}
</style>
